// "Next up…" flow (round-13, 2026-08-31): after a TOURNAMENT match finishes, the result overlay
// shows the next pending pairing with both profiles dimmed; each player scans their badge to
// "check in", and once both have scanned LiveMatch.vue auto-starts that bracket slot's match.
// Module-level (like draft.ts) so useGlobalScanner.ts — which owns all badge scans — can mark a
// scan against it without any screen plumbing.
import { reactive } from 'vue'
import type { Player } from '../types'

interface NextUpState {
  slotId: number | null
  left: Player | null
  right: Player | null
  scanned: Record<number, boolean>
}

export const nextUp = reactive<NextUpState>({ slotId: null, left: null, right: null, scanned: {} })

export function setNextUp(slotId: number, left: Player, right: Player) {
  nextUp.slotId = slotId
  nextUp.left = left
  nextUp.right = right
  nextUp.scanned = {}
}

export function clearNextUp() {
  nextUp.slotId = null
  nextUp.left = null
  nextUp.right = null
  nextUp.scanned = {}
}

/** True if `player` is one of the two up next (marks them checked in). */
export function markNextUpScanned(player: Player): boolean {
  if (nextUp.slotId == null) return false
  if (player.id !== nextUp.left?.id && player.id !== nextUp.right?.id) return false
  nextUp.scanned = { ...nextUp.scanned, [player.id]: true }
  return true
}

export function nextUpReady(): boolean {
  return nextUp.slotId != null && !!nextUp.left && !!nextUp.right && !!nextUp.scanned[nextUp.left.id] && !!nextUp.scanned[nextUp.right.id]
}
